import { useRef } from 'react';

import cn from 'classnames';

import OTooltip from '../OTooltip';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import { BsChevronDown } from 'react-icons/bs';

import { IOSelectProps } from './OSelect.types';

import './oSelect.scss';

const OSelect: React.FC<IOSelectProps> = ({
  items,
  label,
  size = 'medium',
  alignItems = 'center',
  isDisabled,
  icon,
  classes,
  selectedValue,
  tooltipContent,
  shouldDisableDropdown,
  onChange,
  onClick = () => {},
  autoWidth,
}) => {
  const selectRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className={cn('o-select-container', `align-${alignItems}`)}>
      {label && <label className={cn('label', classes?.customLabel)}>{label}</label>}
      <OTooltip title={tooltipContent}>
        <>
          <Select
            id="o-select"
            value={selectedValue}
            ref={selectRef}
            onChange={(event) => onChange(event.target.value)}
            onClick={onClick}
            displayEmpty
            onMouseDown={(e) => {
              if (shouldDisableDropdown) {
                e.preventDefault();
              }
            }}
            open={shouldDisableDropdown ? false : undefined}
            autoWidth={autoWidth}
            className={cn(
              'select-container',
              { disabled: isDisabled },
              size,
              classes?.selectContainer,
              classes?.customTextSize
            )}
            IconComponent={({ className, ...props }) => (
              <BsChevronDown className={cn('chevron-down', className)} {...props} size={18} />
            )}
            sx={{
              backgroundColor: 'var(--o-select-background)',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: classes?.customBorderColor ? '#D8DEDE' : 'var(--o-select-border-color);',
                transition: 'border-color 0.3s ease',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: classes?.customBorderColor
                  ? classes.customBorderColor
                  : 'var(--o-select-border-hover-color)',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: classes?.customBorderColor
                  ? classes.customBorderColor
                  : 'var(--o-select-border-hover-color)',
                borderWidth: 2,
              },
            }}
            classes={{
              root: 'select-root',
              select: cn('select-input', classes?.customInput),
            }}
            disabled={isDisabled}
            MenuProps={{
              classes: {
                paper: 'menu-paper',
                root: 'menu-root',
                list: classes?.customMenuBackground ? classes.customMenuBackground : 'menu-list-container',
              },
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
            }}
          >
            {items.map(({ label, value }, index) => (
              <MenuItem className="menu-item" value={value} key={`${value}-${index}`} sx={{ pt: 2 }}>
                {icon && <ListItemIcon className="list-item-icon">{icon}</ListItemIcon>}
                <ListItemText primary={label} className="menu-item-text" sx={{ textTransform: 'none' }} />
              </MenuItem>
            ))}
          </Select>
        </>
      </OTooltip>
    </div>
  );
};

export default OSelect;
